import { delegator } from './elements/delegator';
import { scroller } from './elements/scroll';
import { modal } from './elements/modal';
import { a11yManager } from './elements/a11y-hidden';
import '/Applications/MAMP/htdocs/bulteau/components/common/main-header/main-header.js'; import '/Applications/MAMP/htdocs/bulteau/components/homepage/brands/brands.js'; import '/Applications/MAMP/htdocs/bulteau/components/homepage/contact/contact.js'; import '/Applications/MAMP/htdocs/bulteau/components/homepage/history/history.js';
document.documentElement.classList.add('js');
window.addEventListener('DOMContentLoaded', function (event) {
  // init device context
  window.device = {
    muted: false,
    animation: !window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    touch: !window.matchMedia('(pointer: fine)').matches,
    ios: navigator && navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/)
  };
  document.dispatchEventDelegate('APP:READY');
});